/***************************************************************************
 * ========================================================================
 * Copyright (c) 2026 Broadcom Inc. and/or its subsidiaries. All Rights Reserved. Broadcom Confidential.
 * ========================================================================
 */

const moduleName = 'match';
const componentName = 'port-match';
const prefix = `${moduleName}.${componentName}`;

export const portMatchLabel = `${prefix}.portMatchLabel`;
export const portMatchInputPlaceholder = `${prefix}.portMatchInputPlaceholder`;
export const portMatchHelperText = `${prefix}.portMatchHelperText`;

export const ENGLISH = {
    [portMatchLabel]: 'Ports',
    [portMatchInputPlaceholder]: 'Enter Port',
    [portMatchHelperText]: 'Accepts single value, comma separate, and ranges',
};
